import {
  Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupLabel,
  SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { APP_VERSION } from "@/lib/version"
import {
  LayoutDashboard, Users, KeyRound, Server, PersonStanding,
  ChevronsUpDown, LogOut, Bell, CreditCard, BadgeCheck, ShieldCheck, Boxes, Bug,
} from "lucide-react"
import { SidebarMenuBadge } from "@/components/ui/sidebar"

const nav = [
  { id:'dashboard', label:'Dashboard',    icon: LayoutDashboard  },
  { id:'clients',   label:'Clients',      icon: Users            },
  { id:'avatars',   label:'Avatars',      icon: PersonStanding   },
  { id:'api',       label:'API Settings', icon: KeyRound         },
  { id:'vps',       label:'VPS Monitor',  icon: Server           },
  { id:'admins',    label:'Admin Users',  icon: ShieldCheck      },
  { id:'modules',   label:'Modules',      icon: Boxes            },
  { id:'debug',     label:'Debug',        icon: Bug              },
]

export function AdminSidebar({ active, onNav, onLogout, counts = {} }: {
  active: string
  onNav: (id: string) => void
  onLogout: () => void
  counts?: Record<string, number>
}) {
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground flex-shrink-0">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" rx="1"/>
                  <rect x="14" y="3" width="7" height="7" rx="1"/>
                  <rect x="3" y="14" width="7" height="7" rx="1"/>
                  <rect x="14" y="14" width="7" height="7" rx="1"/>
                </svg>
              </div>
              <div className="flex flex-col text-left leading-tight">
                <span className="text-sm font-semibold truncate">TwinModel</span>
                <span className="text-[10px] text-muted-foreground truncate">{APP_VERSION}</span>
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>General</SidebarGroupLabel>
          <SidebarMenu>
            {nav.map(({ id, label, icon: Icon }) => (
              <SidebarMenuItem key={id}>
                <SidebarMenuButton tooltip={label} isActive={active === id} onClick={() => onNav(id)}>
                  <Icon /><span>{label}</span>
                </SidebarMenuButton>
                {counts[id] !== undefined && (
                  <SidebarMenuBadge>{counts[id]}</SidebarMenuBadge>
                )}
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-foreground text-[11px] font-semibold text-background flex-shrink-0">
                    SA
                  </div>
                  <div className="flex flex-col text-left text-sm leading-tight">
                    <span className="font-medium truncate">Super Admin</span>
                    <span className="text-[10px] text-muted-foreground truncate">admin@twinmodels.io</span>
                  </div>
                  <ChevronsUpDown className="ml-auto size-4" />
                </SidebarMenuButton>
              </DropdownMenuTrigger>
              <DropdownMenuContent side="top" align="end" className="w-56 mb-1">
                <DropdownMenuLabel className="font-normal">
                  <div className="flex flex-col gap-0.5">
                    <span className="text-sm font-medium">Super Admin</span>
                    <span className="text-xs text-muted-foreground">admin@twinmodels.io</span>
                  </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem><BadgeCheck className="mr-2 size-4" />Account</DropdownMenuItem>
                <DropdownMenuItem><CreditCard className="mr-2 size-4" />Billing</DropdownMenuItem>
                <DropdownMenuItem><Bell className="mr-2 size-4" />Notifications</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem className="text-destructive focus:text-destructive" onClick={onLogout}>
                  <LogOut className="mr-2 size-4" />Log out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  )
}
